import { LayoutOffset } from 'editor/src/store/editorModules/layouts/types';

const numberToOffset = (offset: number) =>
  ({
    horizontal: offset,
    vertical: offset,
  }) as LayoutOffset;

export default numberToOffset;
